import { render, staticRenderFns } from "./ActionForm.vue?vue&type=template&id=35284a17&"
import script from "./ActionForm.vue?vue&type=script&lang=js&"
export * from "./ActionForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports